<template>
    <router-link :to="detailRoute"
        class="block no-underline text-inherit p-3 my-2 rounded-lg border-1 transition-all hover:shadow-md border-gray-300 hover:border-customBlue-100 bg-white ">
        <div class="flex flex-col gap-1">
            <div class="flex items-center justify-between gap-2 mb-1">
                <div>
                    <p class="m-0 font-roboto text-[14px] leading-[20px] font-normal text-[#EA8A8A]">
                        {{ show(item.visit_date) == "-" ? '-' : $helper.formatDateTime(item.visit_date) }}
                    </p>
                </div>
                <span v-if="show(item.status_text) != '-'"
:style="{ backgroundColor: getStatusClass(item.status_text) }"
                    class="text-white rounded-md px-2 py-[2px] capitalize block w-fit flex-shrink-0 whitespace-nowrap font-roboto text-[12px] leading-[16px] font-normal"
>
                    {{ formatStatus(item.status_text) }}
                </span>
            </div>

            <!-- partner logo on the right, in line with the ID (like the global search cards) -->
            <div class="flex justify-between items-start gap-2">
                <div class="min-w-0">
                    <span class="text-[#BA90C6] font-roboto text-[13px] leading-[18px] block">ID:</span>
                    <p class="text-[#333333] m-0 font-roboto text-[14px] leading-[20px] font-normal">
                        {{ show(item.id) }}
                    </p>
                </div>
                <img v-if="partnerLogo(item)" :src="partnerLogo(item)" :alt="item.depp_schedule.company_name || 'Partner'"
                    class="w-12 h-10 object-contain flex-shrink-0" @error="$event.target.style.display = 'none'">
            </div>
            <div>
                <span class="text-[#BA90C6] font-roboto text-[13px] leading-[18px] block">Title:</span>
                <p class="text-[#333333] m-0 font-roboto text-[14px] leading-[20px] font-normal">
                    {{ show(item.title) === '-' ? 'Appointment' : item.title }}
                </p>
            </div>
            <div>
                <span class="text-[#BA90C6] font-roboto text-[13px] leading-[18px] block">Consumer Name:</span>
                <p class="text-[#333333] m-0 font-roboto text-[14px] leading-[20px] font-normal">
                    {{ show(item.consumer_name) }}
                </p>
            </div>
            <div>
                <span class="text-[#BA90C6] font-roboto text-[13px] leading-[18px] block">Type:</span>
                <p class="text-[#333333] m-0 font-roboto text-[14px] leading-[20px] font-normal">
                    {{ show(item.type_text) }}
                </p>
            </div>
        </div>
    </router-link>
</template>
<script>

export default {
    components: {
    },
    props: ["item"],
    data() {
        return {
            isOpen: false,
            user: JSON.parse(localStorage.getItem("user")) ?? null
        };
    },
    computed: {
        detailRoute() {
            return { name: "AppointmentDetail", params: { id: this.item.id } };
        },
    },
    mounted() {
    },
    unmounted() {
    },
    methods: {
        // Empty fields show "-"
        // partner (NRG / DEPP) appointment: depp_schedule.status 1 with the company logo (same rule as AppointmentInfo)
        partnerLogo(item) {
            const d = item.depp_schedule;
            return d && [1, "1", true].includes(d.status) && d.company_logo ? d.company_logo : null;
        },
        show(value) {
            return value === null || value === undefined || String(value).trim() === '' ? '-' : value;
        },
        getStatusClass(status) {
            const statusClasses = {
                'EN ROUTE': '#0EA5E9',
                'PENDING': '#F59E0B',
                'CANCELLED': '#B91C1C',
                'NO SALE': '#CA6180',
                'ARRIVED': '#14B8A6',
                'CONVERTED TO BOOKING': '#5992B2',
                'CLOSED': '#374151',
                'DISPOSED': '#686D76',
            };
            return statusClasses[status] || '#6B7280'; // inline style needs a colour, not a class (was 'bg-gray-500' → invisible badge)
        },
        formatStatus(status) {
            return status
                ?.toLowerCase()
                .replace(/\b\w/g, char => char.toUpperCase());
        },
    }
};
</script>